export interface Language {
    name: string;
    code: string;
}

export const languages: Language[] = [
    { name: "English", code: "en" },
    { name: "Deutsch", code: "de" },
    { name: "Svenska", code: "sv" },
    { name: "Română", code: "ro" },
    { name: "Čeština", code: "cz" },
    { name: "Italiano", code: "it" },
    { name: "Magyar", code: "hu" },
    { name: "Nederlands", code: "nl" },
    { name: "Polski", code: "pl" }
];
